import React from "react"

import { ObjectValues } from "utils"
import StrmrmRequestedItemCard from "./StrmrmRequestedItemCard"
import classes from "./StrmrmRequestedItems.module.scss"

const StrmrmRequestedItems = (props) => {
  const {
    requestedItems,
    setRequestedItems,
    selectedFoodOptions,
    setSelectedFoodOptions
  } = props

  const selectedFoodOptionsArray =
    ObjectValues(selectedFoodOptions)

  return (
    <div className={classes["container"]}>
      <table className={classes["table"]}>
        <thead>
          <tr>
            <th></th>
            <th style={{ width: "75%" }}>
              نام کالا
            </th>
            <th style={{ textAlign: "center" }}>
              مقدار درخواستی
            </th>
          </tr>
        </thead>
        <tbody>
          {selectedFoodOptionsArray.map(selectedFoodOption =>
            <StrmrmRequestedItemCard
              key={selectedFoodOption.optionId}
              requestedItems={requestedItems}
              setRequestedItems={setRequestedItems}
              selectedFoodOption={selectedFoodOption}
              setSelectedFoodOptions={setSelectedFoodOptions}
            />
          )}
        </tbody>
      </table >
    </div>
  )
}

export default StrmrmRequestedItems